import React from 'react';
import './PrivacyPolicyPage.css';

function PrivacyPolicyPageTrLite() {
    return (
        <div className="privacy-policy-container">
     <h1>Tasbih Dhikr Lite Gizlilik Politikası</h1>
      <p>Son Güncelleme: 31 Ocak 2024</p>

      <h2>Giriş</h2>
      <p>Tasbih Dhikr Lite uygulamasına hoş geldiniz. Bu gizlilik politikası, uygulamamızı kullandığınızda verilerinizin nasıl işlendiği hakkında sizi bilgilendirmeyi amaçlamaktadır. Bu uygulamadaki tek veri toplama, Google'ın reklam servisi AdMob tarafından yapılmaktadır ve biz aktif olarak herhangi bir kişisel veri toplamamaktayız.</p>

      <h2>1. Kişisel Verilerinizin Toplanması ve Kullanımı</h2>
      <h3>a. Toplanan Veri Tipleri</h3>
      <h4>i. AdMob Üzerinden Veri Kullanımı</h4>
      <p>Uygulamamız, reklamları göstermek için AdMob kullanmaktadır. AdMob, IP adresiniz, cihaz kimliğiniz ve uygulamayı kullanımınızla ilgili bilgiler gibi verileri toplayabilir. Bu bilgiler, reklam deneyimini sağlamak ve geliştirmek için kullanılmaktadır.</p>

      <h3>b. Veri Kullanımı</h3>
      <p>AdMob tarafından toplanan veriler şunlar için kullanılır:</p>
      <ul>
        <li>Uygulama içinde reklamları sağlamak ve kişiselleştirmek.</li>
        <li>Gösterilen reklamların etkinliğini analiz etmek.</li>
      </ul>

      <h3>c. Kullanıcı Kontrolü</h3>
      <p>Kişisel reklamlar için veri kullanımınızı cihaz ayarlarınız üzerinden kontrol edebilirsiniz.</p>

      <h2>2. Veri Transferi</h2>
      <p>Bilgileriniz, veri koruma yasalarının bulunduğunuz yere göre farklılık gösterebilecek başka bir ülke veya bölgedeki bilgisayarlara aktarılabilir ve orada muhafaza edilebilir.</p>

      <h2>3. Kişisel Verilerinizin Açıklanması</h2>
      <p>AdMob tarafından toplanan veriler, Google'ın gizlilik politikası ve yasal gerekliliklere uygun olarak paylaşılabilir.</p>

      <h2>4. Kişisel Verilerinizin Güvenliği</h2>
      <p>Verilerinizin güvenliği bizim için önemlidir. Ancak, İnternet üzerinden yapılan hiçbir iletim yöntemi veya elektronik depolama yöntemi %100 güvenli değildir.</p>

      <h2>5. Diğer Sitelere Bağlantılar</h2>
      <p>Hizmetimiz, başka sitelere bağlantılar içerebilir. Üçüncü taraf bir bağlantıya tıklarsanız, o üçüncü tarafın sitesine yönlendirileceksiniz.</p>

      <h2>6. Bu Gizlilik Politikasındaki Değişiklikler</h2>
      <p>Gizlilik politikamızı zaman zaman güncelleyebiliriz. Değişiklikleri bu sayfada yeni gizlilik politikasını yayınlayarak sizlere bildireceğiz.</p>

      <h2>7. Bize Ulaşın</h2>
      <p>Bu gizlilik politikası hakkında herhangi bir sorunuz varsa, lütfen bize ulaşın.</p>

      <h2>Faydalı Bağlantılar</h2>
      <p><a href="https://policies.google.com/privacy">Google Gizlilik Politikası</a></p>
    </div>
    );
}

export default PrivacyPolicyPageTrLite;
